"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _environment = _interopRequireDefault(require("./environment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var isNativeLazyLoadingSupported;
if (typeof isNativeLazyLoadingSupported === 'undefined') {
  if (_environment.default.isClient) {
    isNativeLazyLoadingSupported = 'loading' in HTMLImageElement.prototype;
  }
}
var _default = isNativeLazyLoadingSupported;
exports.default = _default;